import React from 'react'
import './CUIRadioButton.scss'

const CUIRadioButton = ({
    options=[],
    value=null,
    onChange=()=>{},
    getOptionLabel=(e)=>(e),
    getOptionValue=(e)=>(e),
    color='#155DFC',
    sx={},
  }) => {
  return (
    <div className='CUIRadioButton' style={sx}>
      {options?.map((option, index) => (
        <div 
          className='CUIRadioButton__elem' 
          key={index}
          onClick={() => {onChange(option)}}
          style={{
            ...sx?.elem, 
            background: option?.color ? option?.color : value === getOptionValue(option) && color,
            color: option?.color ? '#fff' : value === getOptionValue(option) && '#fff',
            transition: 'background .5s ease, color .5s ease',
          }}
        >
          {getOptionLabel(option) || 'Non'}
        </div>
      ))}
    </div>
  )
}

export default CUIRadioButton